
export default {
  name: 'ConnectDistributorFailedTitle',
  props: {
    note: {
      type: String,
      default: () => '',
      required: false,
    },
  },
}
